<template>
	<div
		class="component c-schedule padding-y-24 bp-768:padding-y-48"
		:class="{ dark: section.dark_mode }"
		v-bind:style="{
			'background-image': 'url(' + section.backgroundImage + ') ',
		}"
	>
		<div class="row padding-x-12 ">
			<common-header
				:headline="section.headline"
				:sponsor="section.sponsor"
			/>
		</div>
		<div class="c-schedule__content">
			<div
				v-if="template.name === 'schedule-1'"
				class="c-schedule__template-1"
			>
				<div class="row padding-y-12">
					<swiper
						class="c-schedule__list d-none flex-item-1 width-100 padding-6 bp-768:d-flex"
						:options="swiperOption"
						ref="swiperTop"
					>
						<swiper-slide
							class=" c-schedule__desktop  c-schedule__list--item d-flex  padding-6"
							v-for="event in section.scheduleGames"
							:key="event.id"
						>
							<div
								class="c-schedule__list--item-inside align-items-center flex-direction-column position-relative d-flex"
								:class="{ recent: event.game_status === 'O' }"
							>
								<div
									v-if="event.opponent_image != '/'"
									class="c-schedule__list--item-logo"
								>
									<img
										:src="
											event.opponent_image + '?width=150'
										"
										:alt="event.opponent + ' ' + event.id"
									/>
								</div>
								<div
									v-if="
										event.opponent_image === '/' ||
											!event.opponent_image
									"
									class="c-schedule__list--item-logo"
								>
									<img
										src="/images/logos/site/site.png?width=150"
										:alt="event.opponent + ' ' + event.id"
									/>
								</div>
								<div
									class="c-schedule__list--item-date  font-weight-700 font-size-21 line-height-125"
								>
									{{
										event.date
											? moment(event.date).format(
													'MM.DD.YY',
											  )
											: 'N/A'
									}}
								</div>
								<div
									class="c-schedule__list--item-details text-align-center"
								>
									<div
										class="c-schedule__list--item-opponent font-size-16 line-height-150 font-weight-700"
									>
										{{ event.opponent }}
									</div>
									<div
										class="c-schedule__list--item-location font-size-16 line-height-150"
									>
										{{ event.location }}
									</div>
								</div>
								<div
									v-if="event.game_status === 'O'"
									class="c-schedule__list--item-score text-align-center font-weight-700 font-size-14 line-height-125"
								>
									<span v-if="event.result_status === 'T'"
										>TIE</span
									>
									<span v-if="event.result_status === 'W'"
										>WIN</span
									>
									<span v-if="event.result_status === 'L'"
										>LOSS</span
									>
									<div
										v-if="
											event.result_team_score &&
												event.result_opponent_score
										"
									>
										{{
											event.result_team_score +
												'-' +
												event.result_opponent_score
										}}
									</div>
								</div>
								<div
									:class="
										'c-schedule__list--item-indicator ' +
											event.location_indicator
									"
								></div>
								<div
									v-if="
										event.tickets_link &&
											event.game_status != 'O'
									"
									class="c-schedule__list--item-link"
								>
									<a
										:href="event.tickets_link"
										class="s-common__button c-schedule__button c-schedule__more font-size-14 line-height-125 font-weight-700"
										>Buy Tickets</a
									>
								</div>
							</div>
						</swiper-slide>
					</swiper>
					<div
						class="c-schedule__mobile width-100 d-block bp-768:d-none"
					>
						<div class="c-schedule__list flex-item-1 padding-6">
							<div
								class="c-schedule__list--item flex-item-1 d-flex padding-6"
								v-for="event in section.scheduleGames"
								:key="event.id"
							>
								<div
									class="c-schedule__list--item-inside position-relative d-flex"
									:class="{
										recent: event.game_status === 'O',
									}"
								>
									<div
										v-if="event.opponent_image != '/'"
										class="c-schedule__list--item-logo"
									>
										<img
											:src="
												event.opponent_image +
													'?width=100'
											"
											:alt="
												event.opponent + ' ' + event.id
											"
										/>
									</div>
									<div
										v-if="
											event.opponent_image === '/' ||
												!event.opponent_image
										"
										class="c-schedule__list--item-logo"
									>
										<img
											src="/images/logos/site/site.png?width=100"
											:alt="
												event.opponent + ' ' + event.id
											"
										/>
									</div>
									<div
										class="c-schedule__list--item-info flex-item-1"
									>
										<div
											class="c-schedule__list--item-date  font-weight-700 font-size-21 line-height-125"
										>
											{{
												event.date
													? moment(event.date).format(
															'MM.DD.YY',
													  )
													: 'N/A'
											}}
										</div>
										<div
											class="c-schedule__list--item-details"
										>
											<div
												class="c-schedule__list--item-opponent font-size-16 line-height-150 font-weight-700"
											>
												{{ event.opponent }}
											</div>
											<div
												class="c-schedule__list--item-location font-size-16 line-height-150"
											>
												{{ event.location }}
											</div>
										</div>
									</div>
									<div
										v-if="event.game_status === 'O'"
										class="c-schedule__list--item-score text-align-center font-weight-700 font-size-14 line-height-125"
									>
										<span v-if="event.result_status === 'T'"
											>TIE</span
										>
										<span v-if="event.result_status === 'W'"
											>WIN</span
										>
										<span v-if="event.result_status === 'L'"
											>LOSS</span
										>
										<div
											v-if="
												event.result_team_score &&
													event.result_opponent_score
											"
										>
											{{
												event.result_team_score +
													'-' +
													event.result_opponent_score
											}}
										</div>
									</div>
									<div
										:class="
											'c-schedule__list--item-indicator ' +
												event.location_indicator
										"
									></div>
									<div
										v-if="
											event.tickets_link &&
												event.game_status != 'O'
										"
										class="c-schedule__list--item-link"
									>
										<a
											:href="event.tickets_link"
											class="s-common__button c-schedule__button c-schedule__more font-size-14 line-height-125 font-weight-700"
											>Buy Tickets</a
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row padding-x-6 ">
					<div class="c-schedule__key flex-item-1">
						<ul class="reset-list d-flex justify-content-center">
							<li class="N">
								Neutral
							</li>
							<li class="A">
								Away
							</li>
							<li class="H">
								Home
							</li>
						</ul>
					</div>
				</div>
				<div class="row padding-x-24">
					<div class="swiper-arrows d-flex justify-content-center">
						<div
							class="swiper-button-prev d-none  bp-768:d-flex"
							slot="button-prev"
						></div>
						<a
							class="s-common__button c-schedule__more text-align-center margin-0 font-size-14 line-height-125 font-weight-700"
							:href="
								'/sports/' +
									this.$root.signing_day.sport.shortname +
									'/schedule/'
							"
							>Full Schedule</a
						>
						<div
							class="swiper-button-next d-none bp-768:d-flex"
							slot="button-next"
						></div>
					</div>
				</div>
			</div>
			<div
				v-if="template.name === 'schedule-2'"
				class="c-schedule__template-2"
			>
				<div class="row padding-y-12 padding-x-12">
					<ul class="width-100  c-schedule__list ">
						<li
							class=" c-schedule__item  d-flex "
							v-for="event in section.scheduleGames"
							:key="event.id"
							:class="{
								recent: event.game_status === 'O',
							}"
						>
							<div
								class="c-schedule__item--logos d-flex align-items-center"
							>
								<div class="c-schedule__item--logo">
									<img
										src="/images/logos/site/site.png?width=100"
										:alt="event.opponent + ' ' + event.id"
									/>
								</div>
								<div
									class="c-schedule__item--vsat font-size-12 font-weight-400 line-height-150 margin-x-24"
								>
									<span
										v-if="event.location_indicator === 'A'"
										>at</span
									>
									<span
										v-if="event.location_indicator === 'H'"
										>vs.</span
									>
									<span
										v-if="event.location_indicator === 'N'"
										>at</span
									>
								</div>
								<div class="c-schedule__item--logo">
									<img
										v-if="
											event.opponent_image === '/' ||
												!event.opponent_image
										"
										src="/images/logos/site/site.png?width=100&s.grayscale=bt709"
										:alt="event.opponent + ' ' + event.id"
									/>
									<img
										v-if="event.opponent_image != '/'"
										:src="
											event.opponent_image + '?width=100'
										"
										:alt="event.opponent + ' ' + event.id"
									/>
								</div>
							</div>
							<div class="c-schedule__item--details">
								<div
									class="c-schedule__item--details-top d-flex align-items-center"
								>
									<span
										class="c-schedule__item--date font-weight-700 font-size-14 line-height-150"
									>
										{{
											event.date
												? moment(event.date).format(
														'MMM DD',
												  )
												: 'N/A'
										}}
									</span>
									<span
										v-if="event.time"
										class="c-schedule__item--dot margin-x-12"
									></span>
									<span
										v-if="
											event.time &&
												event.game_status != 'O'
										"
										class="c-schedule__item--time line-height-150 font-size-14 font-weight-300"
									>
										{{ event.time ? event.time : 'N/A' }}
									</span>
									<span
										v-if="event.game_status === 'O'"
										class="c-schedule__list--item-score text-align-center line-height-150 font-size-14 font-weight-300"
									>
										<span v-if="event.result_status === 'T'"
											>TIE</span
										>
										<span v-if="event.result_status === 'W'"
											>WIN</span
										>
										<span v-if="event.result_status === 'L'"
											>LOSS</span
										>
										<span
											v-if="
												event.result_team_score &&
													event.result_opponent_score
											"
										>
											{{
												event.result_team_score +
													'-' +
													event.result_opponent_score
											}}
										</span>
									</span>
								</div>

								<div
									class="c-schedule__item--details-bottom margin-y-12"
								>
									<div
										class="c-schedule__item--opponent font-size-24 bp-768:font-size-18 bp-1024:font-size-24 line-height-150 font-weight-300"
									>
										<span>
											<span
												v-if="
													event.location_indicator ===
														'A'
												"
												>at</span
											>
											<span
												v-if="
													event.location_indicator ===
														'H'
												"
												>vs.</span
											>
											<span
												v-if="
													event.location_indicator ===
														'N'
												"
												>at</span
											>
										</span>
										<span>
											{{ event.opponent }}
										</span>
									</div>
								</div>
								<div
									class="c-schedule__item--location  d-flex align-items-center font-size-14 font-weight-300 line-height-150"
								>
									<feather
										type="map-pin"
										size="18"
										class="margin-r-6"
									></feather>
									{{ event.location }}
								</div>
							</div>

							<div
								class="c-schedule__item--link"
								v-if="
									event.tickets_link &&
										event.game_status != 'O'
								"
							>
								<a
									:href="event.tickets_link"
									class="c-schedule__button c-schedule__more font-size-14 line-height-125 font-weight-700"
									>Buy Tickets</a
								>
							</div>
						</li>
					</ul>
					<div
						class="c-schedule__key flex-item-1 d-flex align-items-center justify-content-center"
					>
						<a
							class="s-common__button c-schedule__more text-align-center margin-0 font-size-14 line-height-125 font-weight-700"
							:href="
								'/sports/' +
									this.$root.signing_day.sport.shortname +
									'/schedule/'
							"
							>Full Schedule</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SectionBase from './SectionBase';
import CommonHeader from '@/components/common/CommonHeader.vue';
export default {
	extends: SectionBase,
	name: 'SectionSchedule',
	components: {
		CommonHeader,
	},
	data: function() {
		return {
			swiperOption: {
				slidesPerView: 6,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					1561: {
						slidesPerView: 6,
					},
					1281: {
						slidesPerView: 5,
					},
					1025: {
						slidesPerView: 4,
					},
					768: {
						slidesPerView: 3,
					},
					0: {
						slidesPerView: 1,
					},
				},
			},
		};
	},
};
</script>

<style lang="scss">
.swiper-arrows {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
}
.swiper-button-prev,
.swiper-button-next {
	position: static;
	height: 48px;
	width: 48px;
	border: 1px solid $main-font-color;
	margin: 0 12px;
	&:after {
		font-size: 24px;
		color: $main-font-color;
	}
	&.swiper-button-disabled {
		display: none !important;
	}
}
</style>
<style>
@import url('https://fonts.googleapis.com/css2?family=Heebo:wght@300;700&display=swap');
</style>
<style scoped lang="scss">
.c-schedule__template-1 {
	.c-schedule {
		&__button {
			min-height: 35px;
			margin: 0 0 24px 0;
		}
		&__key {
			margin: 0 0 24px 0;
			ul {
				li {
					color: $main-font-color;
					margin: 0 12px;
					font-size: 10px;
					line-height: 150%;
					font-weight: bold;
					text-align: center;
					font-family: 'Roboto Condensed', sans-serif;
					text-transform: uppercase;
					&:before {
						content: '';
						display: block;
						width: 60px;
						margin: 0 0 6px 0;
						height: 3px;
						background: var(--color-secondary);
					}
					&.A {
						&:before {
							background: $color-safe-text-on-light;
						}
					}
					&.N {
						&:before {
							background: #c3c0c6;
						}
					}
				}
			}
		}
		&__list {
			&--item {
				&-inside {
					color: $main-font-color;
					background: $main-color;
					font-family: Work Sans;
					border: 1px solid $main-border-color;
					box-sizing: border-box;
					border-radius: 10px;
					min-height: 400px;
					display: flex;
					flex: 1;
					padding: 24px 24px 27px 24px;
					&.recent {
						background: #999;
					}
				}
				&-date {
					margin: 0 0 24px 0;
				}
				&-details {
					margin: 0 0 24px 0;
				}
				&-indicator {
					position: absolute;
					bottom: 27px;
					left: 50%;
					transform: translateX(-50%);
					width: 60px;
					height: 3px;
					background: var(--color-secondary);
					&.A {
						background: $color-safe-text-on-light;
					}
					&.N {
						background: #c3c0c6;
					}
				}
				&-logo {
					max-width: 150px;
					margin: 0 0 24px 0;
				}
			}
		}
		&__mobile {
			.c-schedule {
				&__button {
					width: 80px;
					height: 50px;
					font-size: 12px;
					margin: 0;
				}
				&__list {
					&--item {
						&-logo {
							max-width: 100px;
							margin: 0;
						}
						&-info {
							padding: 24px 24px 24px 24px;
						}
						&-inside {
							align-items: center;
							min-height: auto;
							padding: 12px 12px 15px 12px;
						}
						&-indicator {
							bottom: 12px;
						}
						&-score {
							margin: 0 12px;
						}
						&-date {
							margin-bottom: 12px;
						}
						&-details {
							margin: 0;
							display: block;
						}
					}
				}
			}
		}
	}
}
.c-schedule__template-2 {
	.c-schedule {
		&__list {
			margin: 0;
			list-style: none;
			padding: 0;
		}
		&__more {
		}
		&__key {
			margin: 24px 0 0 0;
			ul {
				li {
					color: $main-font-color;
					margin: 0 12px;
					font-size: 10px;
					line-height: 150%;
					font-weight: bold;
					text-align: center;
					font-family: 'Roboto Condensed', sans-serif;
					text-transform: uppercase;
					&:before {
						content: '';
						display: block;
						width: 60px;
						margin: 0 0 6px 0;
						height: 3px;
						background: var(--color-primary);
					}
					&.R {
						&:before {
							background: #eeeeee;
						}
					}
				}
			}
		}
		&__item {
			border: 1px solid $main-border-color;
			border-radius: 10px;
			font-family: 'Heebo', sans-serif;
			margin: 12px 0 0 0;
			background: $main-color;
			color: $main-font-color;
			box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.08);
			padding: 48px;
			&.recent {
				background: #eeeeee;
			}
			&--logos {
				flex-shrink: 0;
				padding-right: 48px;
				border-right: 1px dashed $main-border-color;
			}
			&--logo {
				display: flex;
				align-items: center;
				justify-content: center;
			}
			&--dot {
				height: 4px;
				width: 4px;
				display: block;
				background: $main-border-color;
				border-radius: 50%;
				overflow: hidden;
			}
			&--details {
				padding: 0 48px;
				flex: 1;
				display: flex;
				justify-content: center;
				flex-direction: column;
			}
			&--link {
				flex-shrink: 0;
				display: flex;
				align-items: center;
				padding: 0 0 0 48px;
				border-left: 1px dashed $main-border-color;
				a {
					width: 123px;
					height: 48px;
					background: $color-primary;
					color: $text-on-primary;
					text-decoration: none;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
			&--vsat {
				flex-shrink: 0;
				border: 1px solid $main-border-color;
				border-radius: 50%;
				display: flex;
				background: #fff;
				align-items: center;
				justify-content: center;
				height: 30px;
				width: 30px;
				color: $color-safe-text-on-light;
			}
		}
		@media screen and (max-width: 1279px) {
			&__item {
				&--vsat {
					margin: 0 12px !important;
				}
				&--logo {
					width: 50px;
					height: 50px;
				}
			}
		}
		@media screen and (max-width: 1023px) {
			&__item {
				padding: 24px;
				&--details {
					padding: 0 24px;
				}
				&--link {
					padding-left: 24px;
				}
				&--logos {
					padding-right: 24px;
				}
			}
		}
		@media screen and (max-width: 767px) {
			&__item {
				display: block !important;
				padding: 0;
				&--details {
					padding: 24px;
					text-align: center;
					align-items: center;
				}
				&--link {
					border: none;
					align-items: center;
					justify-content: center;
					width: 100%;
					padding: 0 24px 24px 24px;
				}
				&--logos {
					border: none;
					display: flex;
					padding: 0;
					position: relative;
					border-bottom: 1px solid $main-border-color;
				}
				&--vsat {
					position: absolute;
					top: 50%;
					left: 50%;
					margin: -15px -15px !important;
					z-index: 2;
				}
				&--logo {
					padding: 24px;
					flex: 0 1 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					width: auto;
					height: auto;
					&:first-child {
						border-right: 1px solid $main-border-color;
					}
				}
			}
		}
	}
}
</style>
<style lang="scss">
[data-theme='dark'] {
	.s-home > .component:nth-of-type(odd) {
		.c-schedule__template-1 {
			.c-schedule__list {
				.c-schedule__list--item {
					.c-schedule__list--item-inside {
						background: #151515;
						&.recent {
							background: #0d0d0d;
						}
					}
				}
			}
		}
		.c-schedule__template-2 {
			.c-schedule {
				&__item {
					background: #151515;
					&.recent {
						background: #0d0d0d;
					}
					&--vsat {
						background: #151515;
						color: #fff;
					}
				}
			}
		}
	}
	.c-schedule__template-1 {
		.c-schedule {
			&__key {
				ul {
					li {
						&.A {
							&:before {
								background: $color-safe-text-on-dark;
							}
						}
					}
				}
			}
			&__list {
				&--item {
					&-indicator {
						&.A {
							background: $color-safe-text-on-dark;
						}
					}
					&-inside {
						&.recent {
							background: #0d0d0d;
						}
					}
				}
			}
		}
	}
	.c-schedule__template-2 {
		.c-schedule {
			&__item {
				&.recent {
					background: #0d0d0d;
				}
				&--vsat {
					background: #151515;
					color: #fff;
				}
			}
		}
	}
}
</style>
